import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-svg-symbols',
  templateUrl: './svg-symbols.component.html',
  encapsulation: ViewEncapsulation.None
})

export class SvgSymbolsComponent {
}
